import { useTurboPickupConfig } from 'src/graphql/queries/turboPickup'
import { maskCEP } from 'src/utils/formatCEP'

import { getActiveTurboPickupTags } from './getActiveTurboPickupTags'
import { TurboPickupStoreCard } from './TurboPickupStoreCard'
import type { TurboPickupError, TurboPickupStore } from './types'

type TurboPickupStoreListProps = {
  stores: TurboPickupStore[]
  zipCode: string
  onSelect: (store: TurboPickupStore) => void
  onChangeZip: () => void
  error: TurboPickupError | null
}

const ERROR_MESSAGES: Record<TurboPickupError, string> = {
  INVALID_ZIP: 'CEP inválido. Por favor, confira o número informado.',
  NO_STORES: 'Nenhuma loja disponível para este CEP.',
  API_ERROR: 'Não foi possível buscar as lojas. Tente novamente.',
}

export function TurboPickupStoreList({
  stores,
  zipCode,
  onSelect,
  onChangeZip,
  error,
}: TurboPickupStoreListProps) {
  const turboPickupConfig = useTurboPickupConfig()
  const tagsByPickupId = getActiveTurboPickupTags(
    turboPickupConfig?.configurations
  )

  return (
    <div
      className="flex flex-col gap-4 flex-1 min-h-0"
      data-testid="turbo-pickup-store-list"
    >
      <h3 className="text-[18px] font-semibold text-turboPickupTitle tracking-[-0.45px] leading-[27px]">
        Selecione uma loja
      </h3>

      {error ? (
        <p className="text-sm text-turboPickupBody py-6 text-center">
          {ERROR_MESSAGES[error]}
        </p>
      ) : (
        <ul className="flex flex-col flex-1 min-h-0 overflow-y-auto">
          {stores.map((store) => (
            <TurboPickupStoreCard
              key={store.pickupId}
              store={store}
              tag={tagsByPickupId[store.pickupId]}
              onSelect={onSelect}
            />
          ))}
        </ul>
      )}

      <button
        className="text-sm font-semibold text-turboPickupTitle underline underline-offset-2 text-center mt-2 hover:text-turboPickupLinkHover transition-colors shrink-0"
        onClick={onChangeZip}
      >
        Alterar CEP{zipCode ? ` (${maskCEP(zipCode)})` : ''}
      </button>
    </div>
  )
}
